"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _typeValidation = _interopRequireDefault(require("./typeValidation"));
var _isNotNullOrEmpty = _interopRequireDefault(require("@pcty/utils-commonjs/value/isNotNullOrEmpty"));
var _html = require("@citrus/html");
var _PctyQuestion = require("./PctyQuestion.Common");
var _div;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// using React.memo({}, true) to prevent videos from re-rendering with every answer/response!
var PctyQuestionVideo = /*#__PURE__*/_react.default.memo(function (_ref) {
  var id = _ref.id,
    title = _ref.title,
    videoId = _ref.videoId,
    readOnly = _ref.readOnly,
    onGetViewVideoToken = _ref.onGetViewVideoToken;
  var noVideoPresentText = "";
  var getVideoToken = function getVideoToken() {
    try {
      if (onGetViewVideoToken && (0, _isNotNullOrEmpty.default)(videoId)) {
        onGetViewVideoToken(videoId).then(function (response) {
          setViewToken(response.token);
        });
      }
    } catch (_unused) {}
  };
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    viewToken = _useState2[0],
    setViewToken = _useState2[1];

  // fetch a new viewToken if the videoId has changed (may not need!)
  (0, _react.useEffect)(function () {
    var unmounted = false;
    getVideoToken();
    return function () {
      unmounted = true;
    };
  }, [videoId]);
  if (readOnly) {
    return _div || (_div = /*#__PURE__*/_react.default.createElement("div", null, "<< inserted video >>"));
  }
  if ((0, _isNotNullOrEmpty.default)(videoId)) {
    // wait a bit for the dom to settle
    setTimeout(function () {
      if (window.VidGrid && (0, _isNotNullOrEmpty.default)(viewToken)) {
        window.VidGrid.initPlayer("#video_player-tfv2-".concat(id), {
          videoId: videoId,
          token: viewToken
        });
      }
      //accounts for external survey takers
      else if (window.VidGrid) {
        window.VidGrid.initPlayer("#video_player-tfv2-".concat(id), {
          videoId: videoId
        });
      } else {
        console.error("window.VidGrid was not found! Are you sure you loaded it?");
      }
    }, 500);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "pcty-question-video"
    }, (0, _isNotNullOrEmpty.default)(title) && /*#__PURE__*/_react.default.createElement("div", {
      className: "title"
    }, /*#__PURE__*/_react.default.createElement(_html.Html, {
      content: (0, _PctyQuestion.replaceEmptyPTags)(title),
      id: id + '-video-title'
    })), /*#__PURE__*/_react.default.createElement("vidgrid-player-instance", {
      id: "video_player-tfv2-".concat(id),
      "video-id": videoId,
      token: viewToken
    }));
  } else {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "pcty-question-video"
    }, (0, _isNotNullOrEmpty.default)(title) && /*#__PURE__*/_react.default.createElement("div", {
      className: "title"
    }, /*#__PURE__*/_react.default.createElement(_html.Html, {
      content: (0, _PctyQuestion.replaceEmptyPTags)(title),
      id: id + '-video-title'
    })), noVideoPresentText);
  }
}, function () {
  return true;
});
PctyQuestionVideo.propTypes = {
  /** The text to display above the video in the component. */
  title: _propTypes.default.string,
  /** The id for the component. */
  id: _propTypes.default.string.isRequired,
  /** The videoId for the video. */
  videoId: _propTypes.default.string.isRequired,
  /** Whether or not the question will be readOnly. */
  readOnly: _propTypes.default.bool,
  /** Callback function that receives the viewToken needed for video playback. */
  onGetViewVideoToken: _propTypes.default.func.isRequired,
  __TYPE: function __TYPE(props, propName, componentName) {
    return (0, _typeValidation.default)(props, propName, componentName, 'PctyQuestionVideo');
  }
};
PctyQuestionVideo.defaultProps = {
  __TYPE: 'PctyQuestionVideo'
};
var _default = exports.default = PctyQuestionVideo;